module.exports = __webpack_public_path__ + "img/admin_adv_27.9ec62348.png";